import LogoWordmark from '@/assets/logo-wordmark.svg?react';

interface LoomliteMarkProps {
	size?: number;
	showText?: boolean;
}

const WORDMARK_ASPECT = 713.92 / 294.86;

export function LoomliteMark({ size = 32, showText = true }: LoomliteMarkProps) {
	if (!showText) {
		return (
			<img
				src="/assets/logo.svg"
				alt=""
				aria-hidden="true"
				width={size}
				height={size}
				style={{ display: 'block' }}
			/>
		);
	}
	const height = Math.round(size * 1.6);
	const width = Math.round(height * WORDMARK_ASPECT);
	return (
		<LogoWordmark
			role="img"
			aria-label="loomlite"
			width={width}
			height={height}
			style={{ display: 'block' }}
		/>
	);
}
